module.exports = __webpack_public_path__ + "media/images/servicios-f4aaf198347a466da368d26ad0ed1a55.png";